module.exports = __webpack_public_path__ + "static/media/quickpay.4447e22d.png";